export const getWRMStats = (): unknown => {
	const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};

	return { wrmStats };
};
